import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

var pascalCase = function pascalCase(value) {
  return upperFirst(camelCase(value));
};

export default pascalCase;